"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _tenantConfig = _interopRequireDefault(require("@tezign/tenant-config"));

var configData = {
  SERVER_SIDE_USER_CENTER_API_ORIGIN: 'http://platform-user-center:8080',
  API_ORIGIN: _tenantConfig["default"].value('GLOBAL_API_ORIGIN'),
  AUTH_ORIGIN: _tenantConfig["default"].value('USER_DOMAIN')
};
var tenantDefaultFoundationConfigData = {
  development: configData,
  test: configData,
  stage: configData,
  production: configData
};
var defaultFoundationConfigData = {
  development: {
    SERVER_SIDE_USER_CENTER_API_ORIGIN: 'http://platform-user-center:8080',
    API_ORIGIN: 'https://service.test.tezign.com',
    AUTH_ORIGIN: 'https://id.test.tezign.com'
  },
  test: {
    SERVER_SIDE_USER_CENTER_API_ORIGIN: 'http://platform-user-center:8080',
    API_ORIGIN: 'https://service.test.tezign.com',
    AUTH_ORIGIN: 'https://id.test.tezign.com'
  },
  stage: {
    SERVER_SIDE_USER_CENTER_API_ORIGIN: 'http://platform-user-center:8080',
    API_ORIGIN: 'https://sop-service-stage.tezign.com',
    AUTH_ORIGIN: 'https://id-stage.tezign.com'
  },
  production: {
    SERVER_SIDE_USER_CENTER_API_ORIGIN: 'http://platform-user-center:8080',
    API_ORIGIN: 'https://service.tezign.com',
    AUTH_ORIGIN: 'https://id.tezign.com'
  }
};

var FoundationConfig = /*#__PURE__*/function () {
  function FoundationConfig() {
    (0, _classCallCheck2["default"])(this, FoundationConfig);
    this.data = void 0;
    this.env = void 0;
    this.data = defaultFoundationConfigData;
    this.env = 'production';
  }

  (0, _createClass2["default"])(FoundationConfig, [{
    key: "setConfig",
    value: function setConfig(env, extraOptions) {
      if (extraOptions !== null && extraOptions !== void 0 && extraOptions.isTenant) {
        this.data = tenantDefaultFoundationConfigData;
      }

      this.env = env;
    } // eslint-disable-next-line @typescript-eslint/explicit-function-return-type

  }, {
    key: "get",
    value: function get(key) {
      var env = this.env;
      return this.data[env][key];
    }
  }]);
  return FoundationConfig;
}();

var config = new FoundationConfig();
var _default = config;
exports["default"] = _default;